<template>
  <el-container id="al_area" :style="{background:bj,color:textColor}">
    <el-container class="area_main" :style="{background:bj,color:textColor}">
      <el-aside width="240px" :style="{background:bj1,color:textColor}" style="display:flex;">
        <div style="height:100%;position:relative;overflow: hidden;">
          <el-header height="60px" style="width:240px;display:flex;align-items:center;">
            <p @click="change_max_area" style="width:auto;height:auto;font-size:18px;font-weight:bold;">
              {{ txt_area }}</p>
          </el-header>
          <ul class="left_main" :style="{background:bj1,color:textColor}" style="height:70vh;">
            <li v-for="(g,index) in li_area" :key="g.id" style="height:40px;margin-left:8px;margin-right:8px;"
                @click="btnClick(index)"
                :class="{active:currentIndex === index}">
              <div style="display:flex;width:auto;height:40px;line-height:0.4">
                <p style="width:90%;text-align:left;margin-left:15px;">{{ g.name }}</p>
              </div>
            </li>
          </ul>
          <div class="left_footer" :style="{background:bj1,color:textColor}">
            <div style="height: 1px;background: #F2F2F2"></div>
            <div @click="add_area" style="height:50px;display:flex;justify-content:center;align-items:center;">
              <i class="el-icon-plus"></i>
              <p style="margin-left:10px;margin-right:10px;font-size:15px;">{{ but_addArea }}</p>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container style="margin-left:10px;">
        <el-aside class="my_area" :style="{background:bj1,color:textColor}" height="100%" width="100%">
          <div style="display:flex;height:50px;width:100%;line-height:0.3;text-align:left;align-items: center;">
            <p style="width:auto;font-size:18px;font-weight:bold;margin-left:15px;">{{ txt_lou }}</p>
            <el-button @click="add_son_area()" size="small" type="primary" style="margin-left:auto">{{ $t('添加子分组') }}
            </el-button>
            <el-button @click="change_area()" size="small" type="primary" style="margin-left:10px">{{ $t('修改分组') }}</el-button>
            <el-button @click="del_area()" size="small" style="color:red;margin-right:15px">{{ $t('删除分组') }}</el-button>
          </div>
          <el-main>
            <div :style="{background:org_bj}">
              <vue2-org-tree
                :data="tab_area"
                :style="{background:org_bj}"
                :horizontal="true"
                :label-class-name="labelClassName"
                :renderContent="renderContent"
                collapsable
                @on-expand="onExpand"
                @on-node-click="NodeClick"
                @on-node-mouseover="onMouseover"
                @on-node-mouseout="onMouseout">
              </vue2-org-tree>
              <!-- 创建浮窗盒子 -->
              <!--            <div v-show="BasicSwich" class="floating">-->
              <!--              <p>ID:{{ BasicInfo.id }}</p>-->
              <!--              <p>Name:{{ BasicInfo.label }}</p>-->
              <!--            </div>-->
            </div>
          </el-main>
        </el-aside>
      </el-container>
    </el-container>
    <el-dialog :title="$t('修改区域结构')" center :close-on-click-modal="false"
               width="300px" height="600px" :class=bj_daiLog
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='dai_max_area'> <!--v-draggable 拖动-->
      <div style="margin-left:0;">
          <span style="margin-right:10px; font-size: 13px">
              {{ $t('最大区域：') }}
              <el-select v-model="edi_state" ref='select1'
                         filterable :placeholder="$t('请选择')"
                         style="height:10px; width:150px;">
                <el-option
                  v-for="item in state_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  <!--@click.native="show_table(httpData,roomData)"-->
                </el-option>
              </el-select>
          </span>
      </div>
      <div style="margin-top:30px;">
        <button @click="dai_max_area=false" v-bind:style="{background:dailog_qxbg,color: dailog_qxbg_color, fontSize:'15px',border: '1px solid #0dA7C8',
                          width:'60px',height:'36px'}">{{ $t('退出') }}
        </button>
        <button @click="changeMaxArea()" v-bind:style="{background:dailog_qdbg,color: dailog_qxbg_color, fontSize:'15px',marginLeft:'110px',
          border: '1px solid #0dA7C8', width:'60px',height:'36px'}">{{ $t('保存') }}
        </button>
      </div>
    </el-dialog>
    <el-dialog :title=txt_title center :close-on-click-modal="false"
               width="300px" height="600px" :class=bj_daiLog
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='dai_area'> <!--v-draggable 拖动-->
      <div v-if="show_ld" style="margin-bottom:20px;">
        <span>{{ $t('所属楼栋：') }}</span>
        <el-select v-model="edi_ld" ref='select2' @change="unit_xz()"
                   clearable filterable :placeholder="$t('请选择')"
                   style="height:10px;width:150px; margin-left:0">
          <el-option
            v-for="item in li_ld"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="show_lc" style="margin-bottom:20px;">
        <span>{{ $t('所属楼层：') }}</span>
        <el-select v-model="edi_lc" ref='select2'
                   clearable filterable :placeholder="$t('请选择')"
                   style="height:10px;width:150px; margin-left:0">
          <el-option
            v-for="item in li_lc"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-left:0;">
        <span>{{ txt_name }}</span>
        <el-input :placeholder="$t('请输入名称')" style="width:150px;height:30px;" v-model="edi_name"></el-input>
      </div>
      <div style="margin-top:30px;">
        <button @click="dialog_Onclick($t('退出'))" v-bind:style="{background:dailog_qxbg,color:dailog_qxbg_color, fontSize:'15px',border: '1px solid #0dA7C8',
                          width:'60px',height:'36px'}">{{ $t('退出') }}
        </button>
        <button @click="dialog_Onclick($t('保存'))" v-bind:style="{background:dailog_qdbg,color: dailog_qxbg_color, fontSize:'15px',marginLeft:'110px',
                          border: '1px solid #0dA7C8', width:'60px',height:'36px'}">{{ $t('保存') }}
        </button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('提示')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>{{ $t('您确定要删除此区域吗？') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('取 消') }}</el-button>
        <el-button type="primary" @click=delArea()>{{ $t('确 定') }}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import 'vue2-org-tree/dist/style.css';
import {auto} from "html-webpack-plugin/lib/chunksorter";
/*npm i vue2-org-tree 然后在main.js初始化
 * 报错安装 npm install --save-dev less less-loader*/
export default {
  name:"al_area",
  data() {
    return {
      is_one:true,
      txt_lou:"",
      txt_title:"",
      txt_area:this.$t("全部区域"),
      but_addArea:this.$t("新增区域"),
      edi_state:"unit",
      show_ld:false,
      show_lc:false,
      state_options:[
        // {label:"小区",value:"area"},
        {label:this.$t("楼栋"),value:"building"},
        {label:this.$t("单元"),value:"unit"},
        {label:this.$t("楼层"),value:"floor"}
      ],
      edi_lc:"",
      li_lc:[],
      edi_ld:"",
      li_ld:[],
      li_area:[],
      txt_name:"",
      edi_name:"",
      dai_area:false,
      dai_max_area:false,
      dialogVisible:false,
      maxHeight:window.innerHeight - 175,
      currentIndex:0,
      liDevHead:[
        {'key':this.$t("设备名称"),'val':"name","w":"auto"}
      ],
      tableData:[
        {'name':"1111",'dev_mac':"item","dev_status":"auto"},
        {'name':"1111",'dev_mac':"item","dev_status":"auto"}
      ],
      defHead:[
        {'key':this.$t("设备名称"),'val':"dev_name","w":"auto"},
        {'key':"Mac",'val':"dev_mac","w":"auto"},
        {'key':this.$t("状态"),'val':"dev_status","w":"auto"}
      ],
      tabLiDev:[
        {'dev_name':"1",'dev_mac':"item","dev_status":"auto"},
        {'dev_name':"1",'dev_mac':"item","dev_status":"auto"}
      ],
      BasicSwich:false,
      BasicInfo:{id:null,label:null},
      tab_area:{
        // type: "build",
        // id: 0,
        // label: "XXX科技有限公司",
        // children: [
        //   {
        //     id: 2,
        //     type: "floor",
        //     label: "产品研发部",
        //     backgroundColor: 'red',
        //   },
        // ]
      },
      labelClassName:"tree_bj",
      id:-1,
      id1:-1,
      id2:-1,
      id3:-1,
      id4:-1,
      area_id:-1,
      building_id:-1,
      unit_id:-1,
      floor_id:-1,
      room_id:-1,
      xz_item:0,
      tree_data:{},
      bj:"#283A4D",
      bj1:"#0f2941",
      textColor:"#FFFFFF",
      bj_daiLog:"data-dialog",
      bj_tab:"#FFFFFF",
      bj_dev_txt:"#000000",
      bj_tab_color:"#000000",
      bj_txt_line6:"#000000",
      dailog_qxbg:"#283A4D",
      dailog_qdbg:"#283A4D",
      dailog_qxbg_color:"#FFFFFF",
      dailog_qdbg_color:"#FFFFFF",
      org_bj:"#FFFFFF",
      my_org:"my_org",
      tree_bj:"tree_bj_1"
    };
  },
  methods:{ /*方法存放*/
    renderContent(h,data) { /*通过id1/id2 改变高亮颜色*/
      if (data.id === this.id || data.id === this.id1 || data.id === this.id2 || data.id === this.id3 || data.id === this.id4) {
        return h('div',{
          class:this.tree_bj  // 添加类名也可以使用:label-class-name进行添加
        },[
          h('span',data.label)  // h('br'),h('span', '已完成'),
        ]);
      } else {
        return h('div',[
          h('span',data.label)
        ]);
      }
    },
    btnClick(index) { /*点击楼栋，改变树状图*/
      this.currentIndex = index;
      console.log(index);
      this.xz_item = index;
      this.is_one = true;
      this.init_area(this.li_area,this.xz_item);
    },
    NodeClick(e,data) { /*子按钮点击事件*/
      if (data.type === "1") {
        this.id = data.id;
        this.id1 = -1;
        this.id2 = -1;
        this.id3 = -1;
        this.id4 = -1;
      } else if (data.type === "2") {
        this.id = data.id;
        this.id1 = data.id1;
        this.id2 = -1;
        this.id3 = -1;
        this.id4 = -1;
      } else if (data.type === "3") {
        this.id = data.id;
        this.id1 = data.id1;
        this.id2 = data.id2;
        this.id3 = -1;
        this.id4 = -1;
      } else if (data.type === "4") {
        this.id = data.id;
        this.id1 = data.id1;
        this.id2 = data.id2;
        this.id3 = data.id3;
        this.id4 = -1;
      } else if (data.type === "5") {
        this.id = data.id;
        this.id1 = data.id1;
        this.id2 = data.id2;
        this.id3 = data.id3;
        this.id4 = data.id4;
      }
      // console.log(e) // e 为 event
      console.log(data); // 当前项的所有详情 如：id label children
      this.tree_data = data;
    },
    onMouseout(e,data) { /*树状图移除*/
      this.BasicSwich = false;
    },
    onMouseover(e,data) { /*树状图移入-提示框*/
      this.BasicInfo = data;
      this.BasicSwich = true;
      // var floating = document.getElementsByClassName('floating')[0];
      // floating.style.left = e.clientX + 'px';
      // floating.style.top = e.clientY + 'px';
    },
    collapse(list) { /*折叠效果*/
      var _this = this;
      list.forEach(function (child) {
        if (child.expand) {
          child.expand = false;
        }
        child.children && _this.collapse(child.children);
      });
    },
    onExpand(e,data) { /*展开视图*/
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data,"expand",true);
      }
    },
    toggleExpand(data,val) { /*默认展开*/
      var _this = this;
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this.$set(item,"expand",val);
          if (item.children) {
            _this.toggleExpand(item.children,val);
          }
        });
      } else {
        this.$set(data,"expand",val);
        if (data.children) {
          _this.toggleExpand(data.children,val);
        }
      }
    },
    rowKey(row) {
      return row.id;
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#0f2941;color:#FFFFFF';
    },
    bubbleSort(arr,name) { /*数据排序,防止乱跳*/
      for (var i = 1; i <= arr.length - 1; i++) {
        var preIndex = i - 1;
        var current = arr[i];
        while (preIndex >= 0 && arr[preIndex][name] > current[name]) {
          arr[preIndex + 1] = arr[preIndex];
          preIndex--;
        }
        arr[preIndex + 1] = current;
      }
      return arr;
    },
    get_unit() { /*获取单元*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_unit,params).then(res => {
        this.unit_data = res.data['data'];
        let l = [];
        for (let i = 0; i < this.unit_data.length; i++) {
          let d = {
            value:this.unit_data[i]['unit_id'],
            label:this.unit_data[i]['unit_name']
          };
          l.push(d);
        }
        this.unit_list = l;
        console.log("拿到单元信息",l);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取区域数据失败"));
      });
    },
    get_build() { /*获取楼栋*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_building,params).then(res => {
        this.building_data = res.data['data'];
        let l = [];
        for (let i = 0; i < this.building_data.length; i++) {
          let d = {
            value:this.building_data[i]['building_id'],
            label:this.building_data[i]['building_name']
          };
          l.push(d);
        }
        this.build_list = l;
        console.log("拿到楼栋信息",l);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取区域数据失败"));
      });
    },
    get_area() { /*获取小区*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_area,params).then(res => {
        this.area_data = res.data['data'];
        let l = [];
        for (let i = 0; i < this.area_data.length; i++) {
          let d = {
            value:this.area_data[i]['area_id'],
            label:this.area_data[i]['area_name']
          };
          l.push(d);
        }
        this.area_list = l;
        console.log("拿到区域信息",l);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取区域数据失败"));
      });
    },
    del_area() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.$confirm(this.$t('确认关闭？')).then(_ => {
        done();
      }).catch(_ => {
      });
    },
    delArea() { /*删除区域*/
      this.loading = this.$loading({spinner:"",text:this.$t("正在加载中..."),background:"rgba(0, 0, 0, 0.3)"});
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid')
      };
      let url = this.$urls.ip;
      switch (this.tree_data["locate"]) {
        case "area":
          params["area_id"] = this.tree_data["y_id"];
          url = this.$urls.ip + this.$urls.del_area;
          break;
        case "building":
          params["building_id"] = this.tree_data["y_id"];
          url = this.$urls.ip + this.$urls.del_building;
          break;
        case "unit":
          params["unit_id"] = this.tree_data["y_id"];
          url = this.$urls.ip + this.$urls.del_unit;
          break;
        case "floor":
          params["floor_id"] = this.tree_data["y_id"];
          url = this.$urls.ip + this.$urls.del_floor;
          break;
        case "room":
          params["room_id"] = this.tree_data["y_id"];
          url = this.$urls.ip + this.$urls.del_room;
          break;
      }
      console.log(params);
      this.$api.post(url,params).then(res => {
        this.loading.close();
        console.log(res.data);
        this.$message.success(this.$t("删除成功"));
        this.dialogVisible = false;
        this.is_one = true;
        if (!("id1" in this.tree_data)) {
          this.xz_item = 0;
          this.currentIndex = 0;
        }
        this.getArea();
      }).catch(error => {
        this.loading.close();
        this.dialogVisible = false;
        this.$message.error(this.$t("删除失败"));
      });
    },
    add_area() {
      switch (this.max_area) {
        case "area":
          this.txt_title = this.$t("添加小区");
          this.txt_name = this.$t("小区名称：");
          break;
        case "building":
          this.txt_title = this.$t("添加楼栋");
          this.txt_name = this.$t("楼栋名称：");
          break;
        case "unit":
          this.txt_title = this.$t("添加单元");
          this.txt_name = this.$t("单元名称：");
          break;
        case "floor":
          this.txt_title = this.$t("添加楼层");
          this.txt_name = this.$t("楼层名称：");
          break;
      }
      this.area_id = -1;
      this.building_id = -1;
      this.unit_id = -1;
      this.show_ld = false; /*不显示楼栋和楼层选择框*/
      this.show_lc = false;
      this.dai_area = true;
    },
    add_son_area() { /*添加子区域*/
      if ("locate" in this.tree_data) {
        switch (this.tree_data.locate) {
          case "area":
            this.txt_title = this.$t("添加楼栋");
            this.txt_name = this.$t("楼栋名称：");
            this.area_id = this.tree_data["y_id"];
            break;
          case "building":
            this.txt_title = this.$t("添加单元");
            this.txt_name = this.$t("单元名称：");
            this.building_id = this.tree_data["y_id"];
            break;
          case "unit":
            this.txt_title = this.$t("添加楼层");
            this.txt_name = this.$t("楼层名称：");
            this.unit_id = this.tree_data["y_id"];
            break;
          case "floor":
            this.txt_title = this.$t("添加房间");
            this.txt_name = this.$t("房间名称：");
            this.floor_id = this.tree_data["y_id"];
            break;
          case "room":
            this.txt_title = this.$t("添加房间");
            this.txt_name = this.$t("房间名称：");
            this.floor_id = this.tree_data["y_id1"];
            break;
        }
        console.log(this.unit_id);
        console.log(this.tree_data);
        this.dai_area = true;
      }
    },
    change_area() { /*修改区域*/
      if ("locate" in this.tree_data) {
        switch (this.tree_data.locate) {
          case "area":
            this.txt_title = this.$t("修改小区");
            this.txt_name = this.$t("小区名称：");
            this.area_id = this.tree_data["y_id"];
            this.edi_name = this.tree_data["label"];
            this.show_ld = false;
            this.show_lc = false;
            break;
          case "building":
            this.txt_title = this.$t("修改楼栋");
            this.txt_name = this.$t("楼栋名称：");
            this.building_id = this.tree_data["y_id"];
            this.edi_name = this.tree_data["label"];
            this.show_ld = false;
            this.show_lc = false;
            break;
          case "unit":
            this.txt_title = this.$t("修改单元");
            this.txt_name = this.$t("单元名称：");
            this.unit_id = this.tree_data["y_id"];
            this.edi_name = this.tree_data["label"];
            this.show_ld = false;
            this.show_lc = false;
            break;
          case "floor":
            this.txt_title = this.$t("修改楼层");
            this.txt_name = this.$t("楼层名称：");
            this.floor_id = this.tree_data["y_id"];
            this.edi_name = this.tree_data["label"];
            this.get_ld();
            this.show_ld = true;
            this.show_lc = false;
            this.edi_ld = this.tree_data["y_id1"];
            break;
          case "room":
            this.txt_title = this.$t("修改房间");
            this.txt_name = this.$t("房间名称：");
            this.room_id = this.tree_data["y_id"];
            this.edi_name = this.tree_data["label"];
            this.get_ld();
            this.get_lc();
            this.show_ld = true;
            this.show_lc = true;
            this.edi_lc = this.tree_data["y_id1"];
            this.edi_ld = this.tree_data["y_id2"];
            break;
        }
        this.dai_area = true;
      }
    },
    change_max_area() {
      this.edi_state = this.max_area;
      this.dai_max_area = true;
    },
    dialog_Onclick(v) {
      switch (v) {
        case this.$t("保存"):
          if (this.edi_name === null || this.edi_name.length < 1) {
            this.$message.error(this.$t('请先输入名称'));
          } else {
            switch (this.txt_title) {
              case this.$t("添加小区"):
                this.show_ld = false;
                this.show_lc = false;
                this.add_data("area");
                break;
              case this.$t("添加楼栋"):
                this.show_ld = false;
                this.show_lc = false;
                this.add_data("building");
                break;
              case this.$t("添加单元"):
                this.show_ld = false;
                this.show_lc = false;
                this.add_data("unit");
                break;
              case this.$t("添加楼层"):
                this.show_ld = false;
                this.show_lc = false;
                this.add_data("floor");
                break;
              case this.$t("添加房间"):
                this.show_ld = false;
                this.show_lc = false;
                this.add_data("room");
                break;
              case this.$t("修改小区"):
                this.change_data("area",false);
                break;
              case this.$t("修改楼栋"):
                this.change_data("building",false);
                break;
              case this.$t("修改单元"):
                this.change_data("unit",false);
                break;
              case this.$t("修改楼层"):
                if (this.show_ld) { /*如果显示楼栋-加楼栋判断*/
                  if (this.edi_ld === null || this.edi_ld.length < 1) {
                    this.$message.error(this.$t('请先选择楼栋'));
                  } else {
                    this.change_data("floor",true);
                  }
                } else {
                  this.change_data("floor",false);
                }
                break;
              case this.$t("修改房间"):
                if (this.show_lc) { /*如果显示楼栋-加楼栋判断*/
                  if (this.edi_lc === null || this.edi_lc.length < 1) {
                    this.$message.error(this.$t('请先选择楼层'));
                  } else {
                    this.change_data("room",true);
                  }
                } else {
                  this.change_data("room",false);
                }
                break;
            }
          }
          break;
        case this.$t("退出"):
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.dai_area = false; /*将dialog关闭*/
          break;
      }
    },
    add_data(area) { /*添加区域*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid')
      };
      let url = this.$urls.ip;
      switch (area) {
        case "area":
          params["area_name"] = this.edi_name;
          params["area_bz"] = "";
          url = this.$urls.ip + this.$urls.add_area;
          break;
        case "building":
          if (this.area_id === -1) {
            params["area_id"] = this.area_list[0]["value"];
            params["building_name"] = this.edi_name;
            params["building_bz"] = "";
          } else {
            params["area_id"] = this.area_id;
            params["building_name"] = this.edi_name;
            params["building_bz"] = "";
          }
          url = this.$urls.ip + this.$urls.add_building;
          break;
        case "unit":
          if (this.building_id === -1) {
            params["building_id"] = this.build_list[0]["value"];
            params["unit_name"] = this.edi_name;
            params["unit_bz"] = "";
          } else {
            params["building_id"] = this.building_id;
            params["unit_name"] = this.edi_name;
            params["unit_bz"] = "";
          }
          url = this.$urls.ip + this.$urls.add_unit;
          break;
        case "floor":
          if (this.unit_id === -1) {
            params["kt_unit"] = this.unit_list[0]["value"];
            params["floor_name"] = this.edi_name;
          } else {
            params["kt_unit"] = this.unit_id;
            params["floor_name"] = this.edi_name;
          }
          params["floor_bz"] = "";
          url = this.$urls.ip + this.$urls.add_floor;
          break;
        case "room":
          params["floor_id"] = this.floor_id;
          params["room_name"] = this.edi_name;
          params["room_bz"] = "";
          url = this.$urls.ip + this.$urls.add_room;
          break;
      }
      console.log(params);
      this.$api.post(url,params).then(res => {
        console.log(res.data);
        this.$message.success(this.$t("添加成功"));
        this.dai_area = false;
        this.getArea();
      }).catch(error => {
        this.loading.close();
        this.dai_area = false;
        this.$message.error(this.$t("添加失败"));
      });
    },
    change_data(area,is_add) { /*修改区域*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid')
      };
      let url = this.$urls.ip;
      switch (area) {
        case "area":
          params["area_id"] = this.area_id;
          params["area_name"] = this.edi_name;
          params["area_bz"] = "";
          url = this.$urls.ip + this.$urls.change_area;
          break;
        case "building":
          params["building_id"] = this.building_id;
          params["building_name"] = this.edi_name;
          params["building_bz"] = "";
          url = this.$urls.ip + this.$urls.change_building;
          break;
        case "unit":
          params["unit_id"] = this.unit_id;
          params["unit_name"] = this.edi_name;
          params["unit_bz"] = "";
          url = this.$urls.ip + this.$urls.change_unit;
          break;
        case "floor":
          params["floor_id"] = this.floor_id;
          params["floor_name"] = this.edi_name;
          params["floor_bz"] = "";
          if (is_add) {
            params["unit_id"] = this.edi_ld;
          }
          url = this.$urls.ip + this.$urls.change_floor;
          break;
        case "room":
          params["room_id"] = this.room_id;
          params["room_name"] = this.edi_name;
          params["room_bz"] = "";
          if (is_add) {
            params["floor_id"] = this.edi_lc;
          }
          url = this.$urls.ip + this.$urls.change_room;
          break;
      }
      console.log(params);
      this.$api.post(url,params).then(res => {
        console.log(res.data);
        this.$message.success(this.$t("修改成功"));
        this.dai_area = false;
        if (is_add) {
          this.is_one = true;
        }
        this.getArea();
      }).catch(error => {
        this.loading.close();
        this.dai_area = false;
        this.$message.error(this.$t("修改失败"));
      });
    },
    getArea() { /*获取区域信息*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_area_list,params).then(res => {
        let area_list = res.data['data'];
        console.log("拿到区域信息",area_list);
        let l = [];
        for (let i = 0; i < area_list.length; i++) {
          l.push({
            id:area_list[i]["id"],
            bz:area_list[i]["bz"],
            name:area_list[i]["name"],
            locate:area_list[i]["locate"],
            child:area_list[i]["child"]
          });
        }
        this.li_area = l;
        console.log("处理区域信息",this.li_area);
        if (this.li_area.length > 0) {
          this.init_area(this.li_area,this.xz_item);
        }
        this.loading.close();
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("拿到区域信息失败"));
      });
    },
    init_area(l,item) { /*初始化区域*/
      console.log(item);
      console.log(l[item]["name"]);
      if (l.length >= item && l.length > 0) {
        this.txt_lou = l[item]["name"];
        let d = {
          type:"1",
          id:-1,
          y_id:l[item]["id"],
          label:l[item]["name"],
          locate:l[item]["locate"],
          children:[]
        };
        let l1 = l[item]["child"];
        console.log(this.$t("所有区域,"),l1.length);
        for (let i1 = 0; i1 < l1.length; i1++) {
          d["children"].push({
            type:"2",
            id:i1,
            id1:-1,
            y_id:l1[i1]["id"],
            y_id1:l[item]["id"],
            label:l1[i1]["name"],
            locate:l1[i1]["locate"],
            children:[]
          });
          if (l1[i1]["locate"] === "room") {
            continue;
          }
          let l2 = l1[i1]["child"];
          for (let i2 = 0; i2 < l2.length; i2++) {
            d["children"][i1]["children"].push({
              type:"3",
              id:(i1 + 1) * 100 + i2,
              id1:-1,
              id2:i1,
              y_id:l2[i2]["id"],
              y_id1:l1[i1]["id"],
              y_id2:l[item]["id"],
              label:l2[i2]["name"],
              locate:l2[i2]["locate"],
              children:[]
            });
            if (l2[i2]["locate"] === "room") {
              continue;
            }
            let l3 = l2[i2]["child"];
            console.log("l3",l3.length);
            for (let i3 = 0; i3 < l3.length; i3++) {
              d["children"][i1]["children"][i2]["children"].push({
                type:"4",
                id:(i1 + 1) * 1000 + i2 * 100 + i3,
                id1:-1,
                id2:i1,
                id3:(i1 + 1) * 100 + i2,
                y_id:l3[i3]["id"],
                y_id1:l2[i2]["id"],
                y_id2:l1[i1]["id"],
                y_id3:l[item]["id"],
                label:l3[i3]["name"],
                locate:l3[i3]["locate"],
                children:[]
              });
              if (l3[i3]["locate"] === "room") {
                continue;
              }
              let l4 = l3[i3]["child"];
              for (let i4 = 0; i4 < l4.length; i4++) {
                d["children"][i1]["children"][i2]["children"][i3]["children"].push({
                  type:"5",
                  id:(i1 + 1) * 10000 + i2 * 1000 + i3 * 100 + i4,
                  id1:-1,
                  id2:i1,
                  id3:(i1 + 1) * 100 + i2,
                  id4:(i1 + 1) * 1000 + i2 * 100 + i3,
                  y_id:l4[i4]["id"],
                  y_id1:l3[i3]["id"],
                  y_id2:l2[i2]["id"],
                  y_id3:l1[i1]["id"],
                  y_id4:l[item]["id"],
                  label:l4[i4]["name"],
                  locate:l4[i4]["locate"],
                  children:[]
                });
                if (l4[i4]["locate"] === "room") {
                  continue;
                }
              }
            }
          }
        }
        this.tab_area = d;
        if (this.is_one) {
          this.tree_data = {
            type:"1",
            id:-1,
            y_id:l[item]["id"],
            label:l[item]["name"],
            locate:l[item]["locate"]
          };
          this.id = -1;
          this.id1 = -1;
          this.id2 = -1;
          this.id3 = -1;
          this.id4 = -1;
          this.is_one = false;
        }
        this.toggleExpand(this.tab_area,true); /*默认展开*/
      } else {
        this.txt_lou = "";
        this.tab_area = {};
      }
    },
    changeMaxArea() {  /*修改区域*/
      this.loading = this.$loading({spinner:"",text:this.$t("正在加载中..."),background:"rgba(0, 0, 0, 0.3)"});
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'max_area':this.edi_state
      };
      this.$api.post(this.$urls.ip + this.$urls.change_max_area,params).then(res => {
        console.log(res.data);
        this.$message.success(this.$t("修改成功"));
        this.dai_max_area = false;
        localStorage.setItem("area_max",this.edi_state);
        this.getMaxArea();
        this.getArea();
      }).catch(error => {
        this.loading.close();
        this.dai_max_area = false;
        this.$message.error(this.$t("修改区域信息失败"));
      });
    },
    getMaxArea() { /*获取最大区域*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did')
      };
      this.$api.get(this.$urls.ip + this.$urls.get_max_area,params).then(res => {
        this.max_area = res.data['data']["max_area"];
        console.log("最大区域",this.max_area);
        switch (this.max_area) {
          case "area":
            this.area_id = -1;
            this.txt_area = this.$t("全部小区");
            this.but_addArea = this.$t("新增小区");
            break;
          case "building":
            this.area_id = -1;
            this.txt_area = this.$t("全部楼栋");
            this.but_addArea = this.$t("新增楼栋");
            break;
          case "unit":
            this.building_id = -1;
            this.txt_area = this.$t("全部单元");
            this.but_addArea = this.$t("新增单元");
            break;
          case "floor":
            this.unit_id = -1;
            this.txt_area = this.$t("全部楼层");
            this.but_addArea = this.$t("新增楼层");
            break;
        }
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("拿到区域信息失败"));
      });
    },
    get_ld() { /*获取楼栋信息*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_unit,params).then(res => {
        let data = res.data['data'];
        let l = [];
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['unit_id'],
            label:data[i]['unit_name']
          };
          l.push(d);
        }
        this.li_ld = l;
        console.log(this.$t("拿到楼栋信息"),l);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取楼栋数据失败"));
      });
    },
    get_lc() { /*获取楼层信息*/
      let params = {
        'kt_token':localStorage.getItem('token'),
        'kt_dwid':localStorage.getItem('did'),
        'kt_sonid':localStorage.getItem('kt_sonid'),
        'page':1,
        'pageSize':100000
      };
      this.$api.get(this.$urls.ip + this.$urls.get_floor,params).then(res => {
        let data = res.data['data'];
        let l = [];
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['floor_id'],
            label:data[i]['floor_name'],
            unit_id:data[i]['unit_id']
          };
          l.push(d);
        }
        this.li_lc = l;
        this.list_lc = l;
        console.log(this.$t("拿到楼层信息"),l);
      }).catch(error => {
        this.loading.close();
        this.$message.error(this.$t("获取楼层数据失败"));
      });
    },
    unit_xz() { /*楼栋筛选*/
      this.li_lc = this.list_lc.filter(item => item['unit_id'] === this.edi_ld);
      this.edi_lc = "";
    },
    change_bj(i) {
      if (i === "1") { /*console.log("白色")*/
        this.bj = "#F4F4F4";
        this.bj1 = "#FFFFFF";
        this.textColor = "#000000";
        this.bj_daiLog = "data-dialog_1";
        this.labelClassName = "tree_bj_1";
        this.tree_bj = "tree_bj1_1";
        this.bj_but = "#409EFF";
        this.bj_but_color = "#000000";
        this.bj_but_1 = "#FFFFFF";
        this.dailog_qxbg = "#FFFFFF";
        this.dailog_qdbg = "#FFFFFF";
        this.dailog_qxbg_color = "#000000";
        this.dailog_qdbg_color = "#000000";
        this.bj_tab = "#FFFFFF";
        this.bj_dev_txt = "#000000";
        this.bj_tab_color = "#000000";
        this.bj_txt_line6 = "#000000";
        this.org_bj = "#FFFFFF";
      } else { /*console.log("黑色")*/
        this.bj = "#283A4D";
        this.bj1 = "#0f2941";
        this.textColor = "#FFFFFF";
        this.org_son = "org_son";
        this.my_org = "my_org";
        this.bj_daiLog = "data-dialog";
        this.labelClassName = "tree_bj";
        this.tree_bj = "tree_bj1";
        this.bj_but = "#409EFF";
        this.bj_but_color = "#FFFFFF";
        this.bj_but_1 = "#283A4D";
        this.dailog_qxbg = "#283A4D";
        this.dailog_qdbg = "#283A4D";
        this.dailog_qxbg_color = "#FFFFFF";
        this.dailog_qdbg_color = "#FFFFFF";
        this.bj_tab = "#283A4D";
        this.bj_dev_txt = "#ccc";
        this.bj_tab_color = "#FFFFFF";
        this.bj_txt_line6 = "#FFFFFF";
        this.org_bj = "#0f2940";
      }
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.loading = this.$loading({spinner:"",text:this.$t("正在加载中..."),background:"rgba(0, 0, 0, 0.3)"});
    this.bj = localStorage.getItem('bj');
    this.change_bj(this.bj); /*修改背景*/
    this.get_area();
    this.get_build();
    this.get_unit();
    this.getMaxArea();
    this.getArea();
    this.get_ld();
    this.get_lc();
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
@import '../../assets/css/aTab.css';

#al_area {
  height: 95vh;
  margin: 0;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0;
}

.my_area {
  padding-top: 10px;
  height: auto;
  border-radius: 5px 5px 5px 5px;
}

.area_main {
  padding-top: 10px;
  height: 93vh;
  margin-bottom: 10px;
  border-radius: 5px 5px 5px 5px;
}

.left_main {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow-y: auto;
}

.left_footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  padding: 10px 0;
  line-height: 0.3;
}

.active {
  font-size: 16px;
  background: #E7F0FF;
  color: #134FC2;
  border-radius: 6px 6px 6px 6px;
}

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

.dialog_dai_area {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    background: #FFFFFF;
  }

  .el-dialog__body {
    color: #000000;
    background: #FFFFFF;
  }
}

.tree_bj {
  color: #FFFFFF;
  height: 100%;
  background: #434850;
}

.tree_bj_1 {
  color: #000000;
  height: 100%;
  background: #F4F4F4;
}

.tree_bj1 {
  color: #3a8ee6;
  height: 100%;
}

.tree_bj1_1 {
  color: #3a8ee6;
  height: 100%;
}

/* 盒子css */
.floating {
  background: #D4E3FC;
  width: 160px;
  height: 100px;
  position: absolute;
  color: #434850;
  padding-top: 15px;
  border-radius: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  left: 0;
  top: 0;
  transition: all 0.3s;
  z-index: 999;
  text-align: left;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/gl/glArea.vue